// @ts-nocheck
export const startPractice = () => {
  Alucard.get(
    function () {
      INTERVIEW_LAUNCHER.mode = 'practice';
      INTERVIEW_LIBRARY_MANAGER.add('언어팩 로딩 & 파싱', INTERVIEW_LANGUAGE);
      INTERVIEW_LIBRARY_MANAGER.add('CSS 로딩 & 파싱', INTERVIEW_STYLESHEET);

      INTERVIEW_LIBRARY_MANAGER.setCallback(function () {
        Alucard(function (v) {
          if (Alucard.DETECT.device != 'pc') INTERVIEW_DEFENSE.init(INTERVIEW_DEFENSE.MOBILE);
          else if (Alucard.DETECT.browser != 'chrome') INTERVIEW_DEFENSE.init(INTERVIEW_DEFENSE.ONLY_CHROME);
          else INTERVIEW_LAUNCHER.init();
        }, '/assets/interview/library/common/INTERVIEW_DEFENSE.js');
      });
      INTERVIEW_LIBRARY_MANAGER.callNext();
    },
    '/assets/interview/interviewPractice/js/INTERVIEW_LAUNCHER.js?version=' + Math.random(),
    '/assets/interview/library/common/INTERVIEW_LIBRARY_MANAGER.js?version=' + Math.random(),
    '/assets/interview/library/common/INTERVIEW_Library.js?version=' + Math.random(),
    '/assets/interview/library/common/INTERVIEW_STYLESHEET.js?version=' + Math.random(),
    '/assets/interview/library/common/INTERVIEW_LANGUAGE.js?version=' + Math.random(),
  );
};

export default startPractice;
